<template>
  <div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Solicitud
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-2">
        <span class="data-title">Sometido por:</span>
        <p>{{ item.requestBy | empty }}</p>
      </div>
      <div class="col-12 col-lg-4">
        <span class="data-title">Razón:</span>
        <p>{{ item.reason | empty }}</p>
      </div>
      <div class="col-12 col-lg">
        <span class="data-title">Comentario:</span>
        <p>{{ item.comment | empty }}</p>
      </div>
    </div>
    <div class="row mt-2" v-if="hasDocument">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-file mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Documento
          </div>
        </div>
      </div>
      <div class="col-12">
        <custom-callout class="my-3 custom-callout" :has-toggle="false">
          <div class="row mt-2">
            <div class="col-12 col-lg-3">
              <div>
                <label
                  class="color-secondary-6 font-weight-normal mr-2 font-16"
                >
                  Tipo del Documento:
                </label>
              </div>
              <p>{{ item.documentType | empty }}</p>
            </div>
            <div class="col-12 col-lg-4">
              <div>
                <label
                  class="color-secondary-6 font-weight-normal mr-2 font-16"
                >
                  Nombre del Documento:
                </label>
              </div>
              <p>{{ item.documentTitle | empty }}</p>
            </div>
            <div class="col-12 col-lg">
              <div class="d-flex justify-content-lg-end mr-3">
                <action-button
                  class="btn-action-size ml-2 mt-3"
                  i="fas fa-file-download"
                  variant="success"
                  @click="downloadHandler"
                />
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Determinación de la Solicitud
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-2">
        <span class="data-title">Fecha de Envío:</span>
        <p>{{ item.sendDate | date }}</p>
      </div>
      <div class="col-12 col-lg-4">
        <span class="data-title">Dirección de Envío:</span>
        <p>{{ item.sendAddress | empty }}</p>
      </div>
      <div class="col-12 col-lg">
        <span class="data-title">Asignado a:</span>
        <p>{{ item.assignedTo | empty }}</p>
      </div>
      <div class="col-12 col-lg">
        <span class="data-title">Fecha de Transferencia:</span>
        <p>{{ item.determination?.date | date }}</p>
      </div>
      <div class="col-12 col-lg">
        <span class="data-title">Comentario:</span>
        <p>{{ item.determination?.comment | empty }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import documentService from '@/services/api/document.api.js';
import mixAlert from '@/mixins/alert.mixin';

export default {
  name: 'RequestInfo',
  components: {
    CustomCallout,
    ActionButton,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasDocument() {
      return this.item.documentType && this.item.documentTitle;
    },
  },
  methods: {
    async downloadHandler() {
      await documentService
        .downloadFromServer(this.item.documentId)
        .catch(() => {
          this.ShowToast(
            'Error',
            'Hubo un error al descargar el documento',
            'error'
          );
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep div.custom-callout div.bg-secondary-3 {
  background: #f8f8f8 !important;
}
</style>
